import React from "react"
import CustomAccountingForm from './Form'

export default function DetailsLoanAccountingDetails() {
  return <CustomAccountingForm isUpdate={ false } />
}



// WEBPACK FOOTER //
// ./src/components/Accounting/CustomAccountingRules/Details.js